import Box from '@mui/material/Box';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';

type Option = {
  id: string;
  label: string;
};

interface Props {
  value: Option;
}

const Option = React.memo(function Treatment(props: Props) {
  const { value } = props;

  return (
    <Box display={'flex'} width={'100%'} justifyContent={'space-between'} alignItems={'center'} height={'100%'}>
      <Box textOverflow={'ellipsis'} overflow={'hidden'} title={value.label}>
        {value.label || ''}
      </Box>
      <ChevronDown size={18} />
    </Box>
  );
});

export function renderDataGridOption(params: GridRenderCellParams<Option, any, any>) {
  if (params.value == null) {
    return '';
  }

  return <Option value={params.value} />;
}
